export default function Breadcrumbs(theme) {
	return {
		MuiBreadcrumbs: {
			styleOverrides: {
				root: {
					color: theme.palette.grey[700],
					".MuiLink-root": {
						fontSize: 16,
						fontFamily: "'General Sans', sans-serif",
						fontWeight: 400,
						lineHeight: 1.5,
						color: theme.palette.grey[700],
					},
					".MuiTypography-body1": {
						fontWeight: 500,
					},
				},
			},
		},
	};
}
